import { get } from "lodash";
import { DEFERRAL_REPAYMENT_CONDITIONS } from "@loanbossinc/component-library";
import { defaultField, isContainedInList } from "helpers/row-logic-helper";

export const getRepaymentTerm = data => {
  const value = get(data, "forbearance.repaymentTerm");

  return value ? `Applies ${value}` : "--";
};

export const shouldShowRepaymentTerm = loan => Boolean(get(loan, "forbearance.repaymentTerm")) && isContainedInList(loan, "forbearance.deferralRepaymentConditionId", [
  DEFERRAL_REPAYMENT_CONDITIONS.REPAYMENT_PERIOD
]);

export const shouldShowRepaymentTermEdit = loan => isContainedInList(loan, "forbearance.deferralRepaymentConditionId", [
  DEFERRAL_REPAYMENT_CONDITIONS.REPAYMENT_PERIOD
]);

export const forbearanceMapNestedRows = loan => {
  const items = defaultField(loan, "forbearance");
  if (!items || !items.loanForbearanceCustom || items.loanForbearanceCustom.length === 0) {
    return [];
  }

  return items.loanForbearanceCustom.reduce((accum, item) => {
    accum.push({
      name: defaultField(item, "name"),
      value: defaultField(item, "value")
    });

    return accum;
  }, []);
};

export const shouldShowFfectiveDate = loan => Boolean(get(loan, "forbearance.effectiveDate"));

export const shouldShowPaymentDeferralStartDate = loan => Boolean(get(loan, "forbearance.paymentDeferralStartDate"));

export const shouldShowPaymentDeferralEndDate = loan => Boolean(get(loan, "forbearance.paymentDeferralEndDate"));

export const shouldShowTotalDeferredAmount = loan => Boolean(get(loan, "forbearance.totalDeferred"));

export const shouldShowDeferralRepaymentConditionId = loan => Boolean(get(loan, "forbearance.deferralRepaymentCondition.value"));

export const repaymentTermHasData = loan => Boolean(get(loan, "forbearance.repaymentTerm"));

export const shouldShowCovenants = loan => Boolean(get(loan, "forbearance.covenants"));

export const shouldShowReporting = loan => Boolean(get(loan, "forbearance.reporting"));

export const shouldShowDepositsAndReserves = loan => Boolean(get(loan, "forbearance.depositsAndReserves"));

export const shouldShowDistributionRestrictions = loan => Boolean(get(loan, "forbearance.distributionRestrictions"));

export const shouldShowCustomField = loan => Boolean(get(loan, "forbearance.loanForbearanceCustom")) && get(loan, "forbearance.loanForbearanceCustom").length > 0;
